import React from 'react'
import { connect } from 'react-redux'
import { selectItems } from '../actions/lists'
import { fetchReviews } from '../actions/reviews'

function mapStateToProps(state, props) {
    const { entities: fileEntities, result, isFetching, filters } = state.files
    const filter = filters[props.filterId]
    const searchKey = filter && filter.searchKey

    return {
        fileEntities,
        pages: result[searchKey] || {},
        filter,
        isFetching,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        select: (ids, filterId) => dispatch(selectItems('files', ids, filterId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
